import { render } from "./MsMessageBox.vue?vue&type=template&id=27bc9609&scoped=true"
import script from "./MsMessageBox.vue?vue&type=script&lang=js"
export * from "./MsMessageBox.vue?vue&type=script&lang=js"

import "./MsMessageBox.vue?vue&type=style&index=0&id=27bc9609&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27bc9609"]])

export default __exports__